import { createFetch } from '@vueuse/core';
import useApp from '@/composables/useApp.ts';

export default function useApi() {
    const app = useApp();

    return createFetch({
        baseUrl: app.site.url + 'api/',
        options: {
            onFetchError(ctx) {
                const data = ctx.data ? JSON.parse(ctx.data) : null;

                if (data?.redirect) {
                    window.location.href = data.redirect;
                }

                return ctx;
            },
            beforeFetch(ctx) {
                if (ctx.options.method === 'POST') {
                    ctx.options.headers = {
                        ...ctx.options?.headers,
                        Accept: 'application/json',
                        'X-CSRF-Token': app.csrf.token,
                        'X-Requested-With': 'XMLHttpRequest',
                    };
                }

                return ctx;
            },
            afterFetch(ctx) {
                ctx.data = JSON.parse(ctx.data);
                return ctx;
            },
        },
    });
}
